import React from 'react';
import { i18n } from '@lt/localization';

import type { IFilter } from '../types';
import CustomBooleanFilterGroup from '../components/CustomBooleanFilterGroup';

const FilterDirectFlight = ({
  className = '',
  isMobile = false,
  ...props
}: IFilter): JSX.Element => (
  <CustomBooleanFilterGroup
    className={className}
    isMobile={isMobile}
    {...props}
    Filter={{
      filterLabel: i18n.t('filters.directFlight.title'),
      FILTER_NAMES,
      customFilters: Object.keys(FILTER_NAMES),
    }}
  />
);

const FILTER_NAMES = {
  direct_flight: i18n.t('filters.directFlight.option'),
};

export default Object.assign(FilterDirectFlight, {
  filterName: 'flight',
  filterLabel: i18n.t('filters.directFlight.title'),
  FILTER_NAMES,
  customFilters: Object.keys(FILTER_NAMES),
});
